// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  groupId: __t.u64().primaryKey().name("group_id"),
  worldId: __t.u64().name("world_id"),
  regionX: __t.i32().name("region_x"),
  regionZ: __t.i32().name("region_z"),
  assetId: __t.u64().name("asset_id"),
  renderMode: __t.string().name("render_mode"),
});
